import { render } from "./SessionExpiredDialog.vue?vue&type=template&id=38fba0fa"
import script from "./SessionExpiredDialog.vue?vue&type=script&lang=js"
export * from "./SessionExpiredDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__